"use client";

import classes from "./toast.module.css";
import AlertTriangle from '@/assets/svg/icons/alert-triangle.svg';
import CheckCircle from '@/assets/svg/icons/check-circle.svg';
import SvgZap from '@/assets/svg/icons/zap.svg';
import SvgX from '@/assets/svg/icons/x.svg';
import FeaturedIcon from "../icons/featured_icon";
import CustomSVG from "@/components/common/svg";
import AlertCircle from '@/assets/svg/icons/alert-circle.svg';
import Info from '@/assets/svg/icons/info.svg';
import { useEffect } from "react";

export default function Toast({type, svg, header_text, sub_text, x_click, duration = 12000}) {
    useEffect(() => {
        const toast_timeout = setTimeout(() => { x_click(); }, duration);
        
        return () => clearTimeout(toast_timeout)
    }, [])

    let icon;
    let main_text_type = "text-sm-bold";
    let sub_text_type = "text-xs-regular";

    switch(type) {
        case "info":
            icon = Info;
            main_text_type = `${main_text_type} color-gray-800`;
            sub_text_type = `${sub_text_type} color-gray-500`;
            break;
        case "error":
            icon = AlertCircle;
            main_text_type = `${main_text_type} color-error-700`;
            sub_text_type = `${sub_text_type} color-error-600`;
            break;
        case "warning":
            icon = AlertTriangle;
            main_text_type = `${main_text_type} color-warning-700`;
            sub_text_type = `${sub_text_type} color-warning-600`;
            break;
        case "success":
            icon = CheckCircle;
            main_text_type = `${main_text_type} color-success-700`;
            sub_text_type = `${sub_text_type} color-success-600`;
            break;
        default:
            icon = SvgZap;
            main_text_type = `${main_text_type} color-gray-700`;
            sub_text_type = `${sub_text_type} color-gray-600`;
            break;
    }

    if(svg) icon = svg;
    
    return <div className={`${classes.toast} ${classes[type]} ${sub_text ? "align-items-start" : "align-items-center"}`}>
        <FeaturedIcon size="sm" color={type} icon={icon} outline />
        <div className="d-flex align-items-start flex-column gap-1">
            {header_text && <div className={main_text_type}>{header_text}</div>}
            {sub_text && <div className={sub_text_type}>{sub_text}</div>}
        </div>
        <CustomSVG className="ms-auto stroke-gray-800 pointer flex-shrink-0" SvgFunction={SvgX} height={16} width={16} onClick={x_click} />
    </div>
}